import React, {Component} from 'react';
import _ from 'lodash';
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import style from './styles.scss';

export default class ComponentPage extends Component {

  static propTypes = {
    component: PropTypes.object,
    props: PropTypes.array,
  }

  renderProps() {
    const {props} = this.props;
    const propsKeys = _.chain(props[0]).omit(['componentId']).keys().value();
    return (
      <div>
        <h3 className={style.subtitle}>PROPS</h3>
        <table className={style.propsTable}>
          <thead>
            <tr>
              {_.map(propsKeys, columnKey => <th key={columnKey}>{columnKey}</th>)}
            </tr>
          </thead>
          <tbody>
            {_.map(props, prop => (
              <tr key={prop.name}>
                {_.map(propsKeys, (key, index) => (
                  <td key={index}>{prop[key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderComponentInfo() {
    const {component} = this.props;

    return (
      <div className={style.propsInfo}>
        {component.modifiers &&
        <div>
          <h3 className={style.subtitle}>MODIFIERS</h3>
          <b>{component.displayName}</b> component also support modifiers: <span className={style.modifiers}>{component.modifiers}</span>.
          <div>Learn more about modifiers <Link to="/docs/modifiers">here</Link>.</div>
        </div>}
      </div>
    );
  }

  render() {
    const {component} = this.props;
    return (
      <div className={style.page}>
        <h1 className={style.title}>{component.displayName}</h1>
        <h4 className={style.description}>{component.description}</h4>

        {this.renderProps()}
        {this.renderComponentInfo()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/ComponentPage/index.js